var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":12,"md":"12"}},[(_vm.loading)?_c('Loading',{attrs:{"stretch":""}}):_vm._e(),(_vm.isItem && _vm.isItemLoaded)?_c('Item'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }